import styled from 'styled-components';

import { Button, minWidth } from '@calm-web/design-system';

export const Copy = styled.div`
	display: grid;
	grid-row-gap: 10px;
	margin-bottom: 40px;
	margin-top: 30px;
	text-align: center;

	${minWidth('tablet')} {
		margin-top: 20px;
	}
`;
export const Cta = styled(Button)`
	margin: 0 auto;
	max-width: 560px;
`;
